var React = require('react');

function GooglePlayInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m18.168 15.838-2.866-2.818-10.521 10.375z","key":0}),React.createElement("path",{"d":"m18.168 8.167-13.387-7.557 10.521 10.375z","key":1}),React.createElement("path",{"d":"m22.363 13.427c.858-.67.858-2.18-.057-2.85l-2.808-1.598-3.133 3.024 3.133 3.024z","key":2}),React.createElement("path",{"d":"m2.034 24 12.234-12.002-12.234-11.997v-.001c-.619.319-1.034.9-1.034 1.655v20.69c0 .755.415 1.336 1.034 1.655z","key":3})]);
}

GooglePlayInline.defaultProps = {"id":"Bold","enableBackground":"new 0 0 24 24","height":"512","viewBox":"0 0 24 24","width":"512"};

module.exports = GooglePlayInline;

GooglePlayInline.default = GooglePlayInline;
